export const MOBILE_MENU_OPEN = 'MOBILE_MENU_OPEN';
export const MOBILE_MENU_CLOSE = 'MOBILE_MENU_CLOSE';
export const MOBILE_SEARCH_OPEN = 'SET_MOBILE_SEARCH_OPEN';
export const MOBILE_SEARCH_CLOSE = 'SET_MOBILE_SEARCH_CLOSE';